import React, { useEffect, useRef } from 'react';
import { Route } from 'react-router-dom';
import { isAuthenticated } from '../credentials/auth';

export default function PrivateRoute({ component: Component, ...rest }) {
    const { handleShowInfo, handleScrollAtivated, ...routeProps } = rest;
    const hasInitialized = useRef(false);

    useEffect(() => {
        // Executa apenas uma vez, independente das dependências
        if (!hasInitialized.current) {
            if (handleShowInfo) {
                handleShowInfo(true);
            }
            if (handleScrollAtivated) {
                handleScrollAtivated();
            }
            hasInitialized.current = true;
        }
    });

    return (
        <Route 
            {...routeProps} 
            render={props => {
                if (isAuthenticated()) {
                    return (
                        <Component 
                            {...props}
                            {...rest}
                        />
                    );
                } else {
                    return (
                        <div style={{ 
                            marginTop: '75px', 
                            textAlign: 'center',
                            padding: '20px',
                            color: '#d32f2f'
                        }}>
                            <h1>Acesso não autorizado!</h1>
                            <p>Você não tem permissão para acessar esta página.</p>
                            <p>Por favor, faça login com uma conta válida.</p>
                        </div>
                    );
                }
            }}
        />
    );
}